exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.ng-valid[required], .ng-valid.required {\n  border-left: 5px solid #42A948; }\n/*\nให้ element ทุกตัวที่มี \"ng-invalid\" class ยกเว้น\nแท็ก <form> ให้มีขอบซ้ายมีอหนา 5px มีสีแดง\n.ng-invalid:not(form,tbody,td)  {\n  border-left: 5px solid #a94442; \n}\n*/\n.ng-invalid {\n  border: 1px; }\nselect.ng-invalid {\n  border: 1px solid #a11919; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/revenue-table/revenue-table.component.scss
// module id = ../../../../../src/app/securities-level/revenue-table/revenue-table.component.scss
// module chunks = main